import {
  CartType,
  CheckoutCookie,
  COOKIE_EXPIRY_CART_TYPE_ANONYMOUS,
  COOKIE_EXPIRY_CART_TYPE_CUSTOMER,
  DefaultCookieSettings,
} from "@/lib/ecommerce/commercetools/client-only/constants";
import Cookies from "js-cookie";
import { cookieDomain } from "@/lib/ecommerce/commercetools/client-only/cookies";

export const updateCookieExpiry = () => {
  try {
    if (typeof document === "undefined" || typeof window === "undefined")
      return;

    // Get current cart cookies
    const cartId = Cookies.get(CheckoutCookie.CartId);
    const cartType = Cookies.get(CheckoutCookie.CartType) as CartType;

    if (!cartId || !cartType) return;

    // Determine expiry based on cart type
    let expiryDate: Date;

    if (cartType === CartType.Anonymous) {
      // Anonymous cart - refresh with 1 year expiry (matching Tagular session default)
      expiryDate = new Date(Date.now() + COOKIE_EXPIRY_CART_TYPE_ANONYMOUS);
    } else if (cartType === CartType.Customer) {
      // Customer cart - refresh with ~10 days expiry (matching LMS session default)
      expiryDate = new Date(Date.now() + COOKIE_EXPIRY_CART_TYPE_CUSTOMER);
    } else {
      return; // Invalid cart type
    }

    // Set domain for production - use root domain for any edx.org subdomain
    const domain = cookieDomain();

    // Update cart cookies with new expiry
    Cookies.set(CheckoutCookie.CartId, cartId, {
      expires: expiryDate,
      domain,
      ...DefaultCookieSettings,
    });

    Cookies.set(CheckoutCookie.CartType, cartType, {
      expires: expiryDate,
      domain,
      ...DefaultCookieSettings,
    });
  } catch (error) {
    console.error("Error updating cart cookies:", error);
  }
};
